import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash'
import * as moment from 'moment';

export const isValidDate = (control: AbstractControl): { [key: string]: boolean } => {
  if (!control || !control.value) {
    return null;
  }
  // Try and turn it into a date.
  const date = moment(control.value, 'MMDDYYYY');

  if (!date || !date.isValid()) {
    return { invalidDate: true };
  }

  // Verify that it is newer than 12/31/1900
  if (date.year() < 1901) {
    return { invalidDate: true };
  }

  const today = moment(new Date());
  const lastDayOfYear = moment(today).endOf('year');
  // Check to see if it is the day of the year.  If it is, that is okay.
  if (date.format('MMDDYYYY') === lastDayOfYear.format('MMDDYYYY')) {
    return null;
  }

  // Verify that the date is within 7 days from now.
  const previousWeek = date.subtract(7, 'days');
  if (today < previousWeek) {
    return { invalidDate: true };
  }

  return null;
}

export class DateHelper {
  convertDates(collection: any[], format: string): void {
    _.forEach(collection, (o) => {
      o.Check_CheckDate = moment(o.Check_CheckDate).format(format).toString()
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/Shared/date-helper.ts